import { required, Spacer, TextInputNewProps } from '@jfs/ui-new'
import { TextInputNew } from '../../components/AdminInputs'
import * as Yup from 'yup'
import { DatePickerReact } from '../../components/DatePicker'
import { Dropdown } from '../../components/Dropdown'
import { accountTypeArr } from '../../utils/constants'
import { PaymentModes } from './PaymentModes'

const defaultToDate = () => {
  const today = new Date()
  const currentDate = today.getDate()
  today.setDate(currentDate + 1)
  return today?.getTime()
}
export const alphaNumericValidation = Yup.string()
  .min(8, 'Min allowed length is 8')
  .max(30, 'Max allowed length is 30')
  .matches(/(^$)|(^[a-zA-Z0-9]+$)/, 'Only alpha-numeric characters are allowed')

export const bankIFSCValidation = Yup.string()
  .trim()
  .matches(/^[A-Z|a-z]{4}[0][\d]{6}$/, 'Incorrect IFSC code')
  .required('IFSC is a required field')

const startSchema = Yup.number()
  .min(new Date().getTime(), "Start date can't be before Current date")
  .required('Required!')
const endSchema = Yup.number().min(Yup.ref('startDate'), "End date can't be before Start date").required('Required!')

const textInputStyle = {
  fontSize: 14,
  color: 'BLACK_21',
  placeholderTextColor: 'PRIMARY_GREY',
  borderColor: 'PRIMARY_GREY',
  borderRadius: 4,
  padding: 8,
} as TextInputNewProps
export const formData = (fromDate, toDate, processingEnityData) => {
  console.log('toDate: ', toDate)
  return [
    {
      formItems: [
        {
          fieldName: 'methodTypes',
          displayName: 'modes',
          label: 'Method Type',
          ComponentName: PaymentModes,
        },
        {
          fieldName: 'spacer1',
          ComponentName: Spacer,
        },
        {
          fieldName: 'methodSubTypes',
          displayName: 'submodes',
          label: 'Method SubType',
          ComponentName: PaymentModes,
        },
        {
          fieldName: 'spacer13',
          ComponentName: Spacer,
        },
        {
          fieldName: 'transactionModes',
          displayName: 'transactionModes',
          label: 'Transcation Modes',
          ComponentName: PaymentModes,
        },
        {
          fieldName: 'spacer13',
          ComponentName: Spacer,
        },
        {
          fieldName: 'entityType',
          displayName: 'entityType',
          label: 'Entity Type',
          ComponentName: PaymentModes,
        },
        {
          fieldName: 'accNumber',
          displayName: 'acctNumber',
          label: 'Account Number',
          ComponentName: TextInputNew,
          ...textInputStyle,
          validationSchema: alphaNumericValidation,
        },
        {
          fieldName: 'spacer22',
          ComponentName: Spacer,
        },
        {
          fieldName: 'accountName',
          displayName: 'accountName',
          label: 'Account Name',
          ComponentName: TextInputNew,
          ...textInputStyle,
          validationSchema: required,
        },
        {
          fieldName: 'spacer23',
          ComponentName: Spacer,
        },
        {
          fieldName: 'clientCode',
          displayName: 'clientCode',
          label: 'Client Code',
          ComponentName: TextInputNew,
          ...textInputStyle,
          validationSchema: required,
        },
        {
          fieldName: 'spacer2',
          ComponentName: Spacer,
        },
        {
          fieldName: 'ifscCode',
          displayName: 'ifscCode',
          label: 'IFSC code',
          ComponentName: TextInputNew,
          ...textInputStyle,
          maxLength: 11,
          validationSchema: bankIFSCValidation,
        },
        {
          fieldName: 'spacer3',
          ComponentName: Spacer,
        },
        {
          fieldName: 'accType',
          displayName: 'accountType',
          label: 'Account Type',
          ComponentName: Dropdown,
          title: 'Account Type',
          data: [...accountTypeArr],
          validationSchema: required,
        },
        {
          fieldName: 'processingEntity',
          displayName: 'Processing Entity',
          label: 'Processing Entity',
          ComponentName: Dropdown,
          title: 'Processing Entity',
          data: [...processingEnityData],
          validationSchema: required,
          fullWidthContent: true,
          minWidth: 360,
        },
        {
          fieldName: 'spacer4',
          ComponentName: Spacer,
        },
        {
          fieldName: 'startDate',
          displayName: 'Start Date',
          label: 'Start Date',
          timeInputLabel: 'Select Time',
          showTimeInput: true,
          minDate: new Date(),
          maxDate: toDate > 0 && new Date(toDate) > new Date() ? new Date(toDate) : new Date('2099-12-31 23:59'),
          dateValue: fromDate === 0 ? new Date() : new Date(fromDate),
          dateFormat: 'yyyy-MM-dd HH:mm',
          ComponentName: DatePickerReact,
          validationSchema: startSchema,
          from: 'ess',
          scrollableYearDropdown: true,
          showMonthYearDropdown: true,
          dropdownMode: 'select',
        },
        {
          fieldName: 'spacer5',
          ComponentName: Spacer,
        },
        {
          fieldName: 'endDate',
          displayName: 'End Date',
          label: 'End Date',
          timeInputLabel: 'Select Time',
          showTimeInput: true,
          minDate: new Date(fromDate)?.getTime() > new Date()?.getTime() ? new Date(fromDate) : new Date(),
          maxDate: new Date('2099-12-31 23:59'),
          dateFormat: 'yyyy-MM-dd HH:mm',
          dateValue: toDate === 0 ? defaultToDate() : new Date(toDate),
          validationSchema: endSchema,
          ComponentName: DatePickerReact,
          from: 'ess',
          scrollableYearDropdown: true,
          showMonthYearDropdown: true,
          dropdownMode: 'select',
        },
        {
          fieldName: 'spacer5',
          ComponentName: Spacer,
        },
        {
          fieldName: 'remarks',
          displayName: 'remarks',
          label: 'Remarks',
          ComponentName: TextInputNew,
          ...textInputStyle,
        },
        {
          fieldName: 'spacer7',
          ComponentName: Spacer,
        },
      ],
      onSubmit: () => {
        return ''
      },
    },
  ]
}
